<button
  type="button"
  class="managers-button"
  tooltipPosition="right-center"
  tooltipCustomClass="managers-button__tooltip"
  [attr.aria-label]="'account-team.header-title' | translate"
  [kdsTooltip]="'account-team.header-title' | translate"
>
  <i aria-hidden="true" class="managers-button__icon fa-regular fa-user-group"></i>
</button>
